import React from 'react';
import MusicAlbumDeleteCancelPopup1 from './MusicAlbumDeleteCancelPopup1';
import MusicAlbumDeleteCancelPopup2 from './MusicAlbumDeleteCancelPopup2';
import MusicAlbumDeleteCancelPopup3 from './MusicAlbumDeleteCancelPopup3';
import MusicAlbumDeleteDisabledPopup from './MusicAlbumDeleteDisabledPopup';
import MusicAlbumDeleteConfirmPopup from './MusicAlbumDeleteConfirmPopup';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';

type MusicAlbumDeletePopupSequencePopupName =
  'removeDisabled'|'removeConfirm'|'cancelInfo'|'cancel'|'cancelDone';

export default function MusicAlbumDeletePopupSequence({
  onCancel,
  musicAlbum,
  cancelReasonOptions,
} : {
  musicAlbum: MusicAlbumEntity,
  onCancel: () => void,
  cancelReasonOptions: {
    value: string,
    text: string,
  }[],
}) {
  const [popup, setPopup] = React.useState<MusicAlbumDeletePopupSequencePopupName|null>(null);
  let initialPopup: MusicAlbumDeletePopupSequencePopupName;
  if (
    musicAlbum.release_status === 1
    || musicAlbum.release_status === 3
    || musicAlbum.release_status === 6
    || musicAlbum.release_status === 7
    || musicAlbum.release_status === 8
    || musicAlbum.release_status === 9
  ) {
    initialPopup = 'removeDisabled';
  } else if (
    musicAlbum.release_status === 0
    || musicAlbum.release_status === 5
    || musicAlbum.release_status === 4) {
    initialPopup = 'removeConfirm';
  } else {
    initialPopup = 'cancelInfo';
  }
  if (popup === null) {
    setPopup(initialPopup);
  }
  return (
    <>
      {popup === 'removeDisabled' && (
        <MusicAlbumDeleteDisabledPopup
          musicAlbum={musicAlbum}
          onClose={() => { setPopup(null); onCancel(); }}
        />
      )}
      {popup === 'removeConfirm' && (
        <MusicAlbumDeleteConfirmPopup
          musicAlbum={musicAlbum}
          onCancel={() => { setPopup(null); onCancel(); }}
          onDone={() => { setPopup(null); document.location.href = '/music_albums/'; }}
        />
      )}
      {popup === 'cancelInfo' && (
        <MusicAlbumDeleteCancelPopup1
          onClose={() => { setPopup(null); onCancel(); }}
          onNext={() => { setPopup('cancel'); }}
        />
      )}
      {popup === 'cancel' && (
        <MusicAlbumDeleteCancelPopup2
          musicAlbum={musicAlbum}
          cancelReasonOptions={cancelReasonOptions}
          onCancel={() => { setPopup(null); onCancel(); }}
          onDone={() => { setPopup('cancelDone'); }}
        />
      )}
      {popup === 'cancelDone' && (
        <MusicAlbumDeleteCancelPopup3
          onDone={() => { setPopup(null); document.location.href = '/music_albums/'; }}
        />
      )}
    </>
  );
}
